import React, { useState, useMemo, useEffect } from 'react';
import 'react-calendar/dist/Calendar.css';
import '../styles/Calendar.css';

import Footer from './Footer';
import { Link } from 'react-router-dom';

import { Calendar, ChevronLeft, ChevronRight, X } from 'lucide-react';
import { FaCalendar, FaCalendarDays, FaMapPin } from 'react-icons/fa6';
import axiosPost from '../helper/axios-helper';
import PopupEventCalendar from './CalendarBig';

const EventModal = ({ event, onClose }) => {
  if (!event) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}><X /></button>
        <h2 style={{color: '#fff'}}>{event.title}</h2>
        <div className='modal-info-container'>
            <div className='modal-info-row'>
                <div className='modal-info-pre'>Date: </div>
                <div className='modal-info-item'>{event.date.toDateString()}</div>
            </div>
            <div className='modal-info-row'>
                <div className='modal-info-pre'>Location: </div>
                <div className='modal-info-item'>{event.location}</div>
            </div>
            <div className='modal-info-row' style={{flexDirection: 'column'}}>
                <div className='modal-info-pre'>Description</div>
                <div className='modal-info-item' style={{fontWeight: 500, fontSize: 12, lineHeight: '18px', color:'#fff', marginTop: '10px'}}>{event.description}</div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default function EventCalendar() {
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [prevMonth, setPrevMonth] = useState(new Date());
    const [nextMonth, setNextMonth] = useState(new Date());
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [ showCalendar, setShowCalendar ] = useState(false)

    const [ allEvents, setAllEvents ] = useState([])

    const filteredEvents = useMemo(() => {
        return allEvents.filter(event => {
            // Create date in UTC to avoid timezone issues
            const timestamp = parseInt(event.date) * 1000;
            const utcDate = new Date(timestamp);
            // Use UTC methods to get the correct date
            const eventMonth = utcDate.getUTCMonth();
            const eventYear = utcDate.getUTCFullYear();
            
            return eventMonth === currentDate.getMonth() &&
                eventYear === currentDate.getFullYear() &&
                (selectedFilter === 'all' || event.type === selectedFilter);
        });
    }, [currentDate, selectedFilter, allEvents]);

    const changeMonth = (increment) => {
        setCurrentDate(prevDate => {
            const newDate = new Date(prevDate);
            newDate.setMonth(newDate.getMonth() + increment);
            return newDate;
        });
    };

    const upcomingCantoEvent = useMemo(() => {
        const now = new Date();
        return allEvents
            .map(event => {
                // Create date in UTC to avoid timezone issues
                const timestamp = parseInt(event.date) * 1000;
                const utcDate = new Date(timestamp);
                // Create a date at midnight in local timezone
                const localDate = new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
                return { ...event, date: localDate };
            })
            .find(e => e.type === 'conversation' && e.date > now);
    }, [allEvents]);

    const openEventDetails = (event) => {
        setSelectedEvent(event);
    };

    const closeEventDetails = () => {
        setSelectedEvent(null);
    };

    useEffect(() => {
        fetchCalendar()
    },[])

    useEffect(() => {
        const prev = new Date(currentDate);
        prev.setMonth(currentDate.getMonth() - 1);
        setPrevMonth(prev);

        const next = new Date(currentDate);
        next.setMonth(currentDate.getMonth() + 1);
        setNextMonth(next);
    }, [currentDate]);
    

    const fetchCalendar = () => {

        axiosPost('events_calendar/fetch', {}, {}, (data) => {

            const { success, response } = data;

            if (success) {

                setAllEvents(data.data)
                console.log(data.data);
                

            } else {
                
            }

        })

    }

    return (
        <div style={{marginTop:'100px'}}>
            <div className="event-page">
                <h1>Event Calendar</h1>

                {/* CANTO Conversations Section */}
                <div className="card canto-conversations">
                    <h2>Upcoming CANTO Conversations</h2>
                    <div className="card-content">
                    {upcomingCantoEvent ? (
                        <div style={{ padding: '20px' }}>
                            <h3 style={{ marginBottom: '10px', color: '#40B6BF' }}>{upcomingCantoEvent.title || upcomingCantoEvent.name}</h3>
                            <p style={{ marginBottom: '10px', fontSize: '16px', fontWeight: 'bold' }}>
                                📅 {upcomingCantoEvent.date.toLocaleDateString('en-US', { 
                                    weekday: 'long', 
                                    year: 'numeric', 
                                    month: 'long', 
                                    day: 'numeric' 
                                })}
                            </p>
                            {upcomingCantoEvent.description && (
                                <p style={{ marginBottom: '15px', color: '#fff' }}>
                                    {upcomingCantoEvent.description}
                                </p>
                            )}
                            <button 
                                onClick={() => openEventDetails(upcomingCantoEvent)}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#40B6BF',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}
                            >
                                View Details
                            </button>
                        </div>
                    ) : (
                        <div style={{ 
                            padding: '40px 20px', 
                            textAlign: 'center',
                            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                            borderRadius: '8px'
                        }}>
                            <div style={{ 
                                fontSize: '48px', 
                                marginBottom: '15px',
                                opacity: 0.6
                            }}>
                                💬
                            </div>
                            <h3 style={{ 
                                color: '#2c3e50', 
                                marginBottom: '10px',
                                fontSize: '20px',
                                fontWeight: 'bold'
                            }}>
                                No Upcoming Conversations
                            </h3>
                            <p style={{ 
                                color: '#7f8c8d', 
                                fontSize: '14px',
                                maxWidth: '400px',
                                margin: '0 auto',
                                lineHeight: '1.6'
                            }}>
                                Stay tuned! New CANTO Conversations will be announced soon. Check back later for upcoming events and discussions.
                            </p>
                        </div>
                    )}
                    </div>
                </div>

                {/* Calendar Section */}
                <div className="calendar-header">
                    <button onClick={() => changeMonth(-1)} className="calendar-nav">
                        <ChevronLeft />
                        <div className='calendar-month'>{prevMonth.toLocaleString('default', { month: 'long', year: 'numeric' })}</div>
                    </button>
                    <h2>{currentDate.toLocaleString('default', { month: 'long', year: 'numeric' })}</h2>
                    <button onClick={() => changeMonth(1)} className="calendar-nav">
                        <div className='calendar-month'>{nextMonth.toLocaleString('default', { month: 'long', year: 'numeric' })}</div>
                        <ChevronRight /> 
                    </button>
                </div>

                {/* Event List */}
                <div className="event-list">
                    {filteredEvents.length > 0 ? (
                    filteredEvents.map(event => (
                        <div key={event.id} className="event-card" onClick={() => openEventDetails(event)}>
                            <div className='event-card-image' style={{backgroundImage: `url(${event.image})`}}>
                                <div className='event-card-date'>
                                    <div className='event-card-date-day'>{new Date(event.date * 1000).getUTCDate()}</div>
                                    <div className='event-card-date-month'>{new Date(event.date * 1000).toLocaleString('default', { month: 'short', timeZone: 'UTC' })}</div>
                                </div>
                            </div>    

                            <div className='event-card-info'>
                                <div className='event-card-info-title'>{event.title}</div>
                                <div style={{display: 'flex', alignItems: 'center', paddingTop: '4px', paddingBottom: '10px'}}>

                                    <FaMapPin size={12} color='#2c2c2c' />
                                    <div className='event-card-info-location'>{event.location}</div>

                                </div>
                                <div className='event-card-info-text'>{event.description}</div>

                                <div className='event-card-info-btn'>Register Now</div>
                            </div>
                                         
                        </div>
                    ))
                    ) : (
                    <p>No events for this month and filter.</p>
                    )}
                </div>

                {/* Filter Section */}
                <div className="filter-section">
                    <div>
                        <h3>Filter Events</h3>
                        <select 
                        value={selectedFilter} 
                        onChange={(e) => setSelectedFilter(e.target.value)}
                        >
                            <option value="all">All Events</option>
                            <option value="conversation">CANTO Conversations</option>
                            <option value="connect">CANTO Connect</option>
                            <option value="conference">CANTO Conference</option>
                            <option value="industry">Industry Events</option>
                        </select>
                    </div>
                    
                    <div className='calendarBigBtn' onClick={() => {
                        setShowCalendar(true)
                    }}>
                        <FaCalendarDays size={18} color='#fff'/>
                    </div>
                </div>

                <EventModal event={selectedEvent} onClose={closeEventDetails} />

                {showCalendar && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000
                    }}>
                        <PopupEventCalendar 
                            onClose={() => setShowCalendar(false)} 
                            events={allEvents}
                        />
                    </div>
                )}
            </div>
        </div>
        
    );
}
